import * as zod from 'zod';

export default zod.object({
  generatedWaypointCount: zod.number().int().nonnegative(),
  seedUsed: zod.number().int().nonnegative(),
});
